import React from "react";
import {Table, Button, Modal} from "react-bootstrap";

class CreatedModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {entries, show, onHide} = this.props;

        return (
            <Modal show={show} onHide={onHide} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Новые eMail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <section ref={ref => this.copyContainer = ref}/>

                    <Table responsive>
                        <thead>
                        <tr>
                            <th>eMail</th>
                        </tr>
                        </thead>
                        <tbody>
                        {entries.map(ticket =>
                            <tr key={ticket.email}>
                                <td>{ticket.email}</td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        );
    }

}

export default CreatedModal;
